module.exports = __webpack_public_path__ + "img/serve8.ab5cf3ce.png";